import { ColorEnum } from '@/constants/color'
import {
    mainColors,
    nakedInteractiveBackgroundColors,
    outlineInteractiveBackgroundColors,
    shadowColors,
} from '@/features/ui/buttons/components/Button/constants'
import { Color, Type } from '@/features/ui/buttons/components/Button/types'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { isInteractiveButtonState } from '@/features/ui/buttons/utils'

export const getMainColor = (state: ButtonStateEnum, color: Color) => mainColors[state][color]

export const getBackgroundColor = (type: Type, state: ButtonStateEnum, color: Color) => {
    if (type === 'primary') return getMainColor(state, color)

    if (type === 'outline') {
        if (isInteractiveButtonState(state)) return outlineInteractiveBackgroundColors[color]

        return ColorEnum.Transparent
    }

    if (type === 'naked') {
        if (isInteractiveButtonState(state)) return nakedInteractiveBackgroundColors[color]

        return ColorEnum.Transparent
    }
}

export const getElementColor = (type: Type, state: ButtonStateEnum, color: Color) => {
    if (type === 'primary') {
        if (color === 'neutral') {
            if (state === ButtonStateEnum.Pressed) {
                return ColorEnum.GRAY_200
            }

            return ColorEnum.Black
        }

        return ColorEnum.WHITE
    }

    if (type === 'outline') {
        if (state === ButtonStateEnum.Disabled && color === 'primary') return ColorEnum.GRAY_300

        return getMainColor(state, color)
    }

    if (type === 'naked') return getMainColor(state, color)
}

export const getOutlineBorder = (state: ButtonStateEnum, color: Color) => ({
    borderColor: getElementColor('outline', state, color),
    borderWidth: 2,
})

export const getShadows = (color: Color) => ({
    boxShadow: `0px 0px 4px ${shadowColors[color]}`,
    elevation: 4,
    shadowColor: shadowColors[color],
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 4,
    shadowOpacity: 1,
})
